<template>
  <div class="cont">
    <Navbar :dialogLoginVisible.sync="loginFormShow"></Navbar>

    <div class="d-flex" style="justify-content: center; position: relative">
      <div
        style="
          border-radius: 50%;
          width: 44px;
          height: 44px;
          justify-content: center;
          align-items: center;
          background: #1b1d2e;
          position: absolute;
          left: 0;
          top: 40px;
          z-index: 9;
          cursor: pointer;
        "
        class="d-flex"
        @click="homeBack"
      >
        <el-image
          style="height: 24px; width: 24px"
          :src="require('../assets/img/explore/back.png')"
        >
          <div slot="placeholder" class="image-slot"></div>
        </el-image>
      </div>

      <div
        class="info_cont d-flex"
        :style="{ height: info_cont_height + 'px' }"
      >
        <div class="l">
          <div class="title">
            <div class="title_l">消息中心</div>
            <div class="title_r" @click="readAll" v-if="totalMessageNum > 0">
              一键已读
            </div>
          </div>

          <div
            class="l_item"
            :class="{ active: tabIndex == 0 }"
            @click="tabClick(0)"
          >
            <el-image
              style="width: 20px; height: 20px; margin-right: 8px"
              v-if="tabIndex == 0"
              :src="require('../assets/img/message/img1act.png')"
              fit="contain"
            >
              <div slot="placeholder" class="image-slot"></div>
            </el-image>
            <el-image
              style="width: 20px; height: 20px; margin-right: 8px"
              v-else
              :src="require('../assets/img/message/img1.png')"
              fit="contain"
            >
              <div slot="placeholder" class="image-slot"></div>
            </el-image>
            <div style="flex: 1">官方通知</div>
            <div class="badge" v-if="officeNum > 0">{{ officeNum }}</div>
          </div>
          <div
            class="l_item"
            :class="{ active: tabIndex == 1 }"
            @click="tabClick(1)"
          >
            <el-image
              style="width: 20px; height: 20px; margin-right: 8px"
              v-if="tabIndex == 1"
              :src="require('../assets/img/message/img2act.png')"
              fit="contain"
            >
              <div slot="placeholder" class="image-slot"></div>
            </el-image>
            <el-image
              style="width: 20px; height: 20px; margin-right: 8px"
              v-else
              :src="require('../assets/img/message/img2.png')"
              fit="contain"
            >
              <div slot="placeholder" class="image-slot"></div>
            </el-image>
            <div style="flex: 1">收到的赞</div>
            <div class="badge" v-if="zanNum > 0">{{ zanNum }}</div>
          </div>
          <div
            class="l_item"
            :class="{ active: tabIndex == 2 }"
            @click="tabClick(2)"
          >
            <el-image
              style="width: 20px; height: 20px; margin-right: 8px"
              v-if="tabIndex == 2"
              :src="require('../assets/img/message/img3act.png')"
              fit="contain"
            >
              <div slot="placeholder" class="image-slot"></div>
            </el-image>
            <el-image
              style="width: 20px; height: 20px; margin-right: 8px"
              v-else
              :src="require('../assets/img/message/img3.png')"
              fit="contain"
            >
              <div slot="placeholder" class="image-slot"></div>
            </el-image>
            <div style="flex: 1">应用我的</div>
            <div class="badge" v-if="yingyongNum > 0">{{ yingyongNum }}</div>
          </div>
          <div
            class="l_item"
            :class="{ active: tabIndex == 3 }"
            @click="tabClick(3)"
          >
            <el-image
              style="width: 20px; height: 20px; margin-right: 8px"
              v-if="tabIndex == 3"
              :src="require('../assets/img/message/img4act.png')"
              fit="contain"
            >
              <div slot="placeholder" class="image-slot"></div>
            </el-image>
            <el-image
              style="width: 20px; height: 20px; margin-right: 8px"
              v-else
              :src="require('../assets/img/message/img4.png')"
              fit="contain"
            >
              <div slot="placeholder" class="image-slot"></div>
            </el-image>
            <div style="flex: 1">关注我的</div>
            <div class="badge" v-if="guanzhuNum > 0">{{ guanzhuNum }}</div>
          </div>
        </div>
        <div class="r">
          <div class="empty" v-if="his_list.length == 0">
            <el-image
              :style="{ height: 150 + 'px', width: 150 + 'px' }"
              :src="require('../assets/img/DrawingBoard/empty.png')"
              fit="contain"
            >
              <div slot="placeholder" class="image-slot"></div>
            </el-image>
            <div class="desc">暂无内容</div>
          </div>
          <vue-loadmore
            :on-loadmore="onLoad"
            :finished="finished"
            :finished-text="' '"
            class="his_item_container"
            :loadDistance="300"
            v-if="isShow"
          >
            <template v-if="tabIndex == 0">
              <div class="item1" v-for="(item, idx) in his_list">
                <div class="top">
                  <div class="isnew" v-if="item.status == 1"></div>
                  <div class="_title">
                    {{ item.title }}
                  </div>
                  <div
                    class="date"
                    @click="toggleOffice(idx)"
                    v-if="!item.open"
                  >
                    <i class="el-icon-arrow-down"></i>
                    展开
                  </div>
                  <!-- <div class="date" @click="toggleOfficeClose(idx)" v-if="item.open">
                    <i class="el-icon-arrow-up"></i> 收起
                  </div> -->
                </div>
                <div class="_bot" v-if="!item.open">
                  {{ item.createdAt }}
                </div>

                <div
                  class="content"
                  v-html="formatWord(item.content)"
                  v-if="item.open"
                ></div>
                <div class="img_cont" v-if="item.imgs && item.open">
                  <el-image
                    style="
                      width: 160px;
                      height: 160px;
                      margin-right: 8px;
                      border-radius: 10px;
                    "
                    :src="img"
                    fit="contain"
                    v-for="img in item.imgs"
                  >
                    <div slot="placeholder" class="image-slot"></div>
                  </el-image>
                </div>
                <div
                  class="_bot"
                  v-if="item.open"
                  style="margin-top: 32px; display: flex"
                >
                  <div style="flex: 1">{{ item.createdAt }}</div>
                  <div
                    class="date"
                    @click="toggleOfficeClose(idx)"
                    v-if="item.open"
                    style="font-size: 16px"
                  >
                    <i class="el-icon-arrow-up"></i>
                    收起
                  </div>
                </div>
              </div>
            </template>

            <template v-if="tabIndex == 1">
              <div class="news_item" v-for="(item, idx) in his_list">
                <el-image
                  class="ava"
                  :src="item.photo"
                  fit="cover"
                  @click="gotoPersonal(item)"
                >
                  <div slot="placeholder" class="image-slot"></div>
                </el-image>

                <div class="center">
                  <div class="t">
                    <div class="name" @click="gotoPersonal(item)">
                      {{ item.uname }}
                    </div>
                    <div class="value">赞了你的作品</div>
                  </div>
                  <div class="b">{{ item.createdAt }}</div>
                </div>

                <el-image
                  class="_img"
                  :src="JSON.parse(item.content).imgUrl"
                  fit="cover"
                >
                  <div slot="placeholder" class="image-slot"></div>
                </el-image>
              </div>
            </template>

            <template v-if="tabIndex == 2">
              <div class="news_item" v-for="(item, idx) in his_list">
                <el-image
                  class="ava"
                  :src="item.photo"
                  fit="cover"
                  @click="gotoPersonal(item)"
                >
                  <div slot="placeholder" class="image-slot"></div>
                </el-image>

                <div class="center">
                  <div class="t">
                    <div class="name" @click="gotoPersonal(item)">
                      {{ item.uname }}
                    </div>
                    <div class="value">应用了你的作品</div>
                  </div>
                  <div class="b">{{ item.createdAt }}</div>
                </div>

                <el-image
                  class="_img"
                  :src="JSON.parse(item.content).imgUrl"
                  fit="cover"
                >
                  <div slot="placeholder" class="image-slot"></div>
                </el-image>
              </div>
            </template>

            <template v-if="tabIndex == 3">
              <div class="news_item" v-for="(item, idx) in his_list">
                <el-image
                  class="ava"
                  :src="item.photo"
                  fit="cover"
                  @click="gotoPersonal(item)"
                >
                  <div slot="placeholder" class="image-slot"></div>
                </el-image>

                <div class="center">
                  <div class="t">
                    <div class="name" @click="gotoPersonal(item)">
                      {{ item.uname }}
                    </div>
                    <div class="value">关注了你</div>
                  </div>
                  <div class="b">{{ item.createdAt }}</div>
                </div>

                <div
                  class="btn1"
                  v-if="!item.isGz"
                  @click.stop="fensiAddGz(item, idx)"
                >
                  回关
                </div>
                <div
                  class="btn2"
                  v-if="item.isGz"
                  @click.stop="fensicancelGz(item, i)"
                >
                  已回关
                </div>
              </div>
            </template>
          </vue-loadmore>
        </div>
      </div>
    </div>
    <Status></Status>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import NavbarLeft from "@/components/NavbarLeft.vue";
import { user_account_req } from "@/api/user";
import {
  msg_typeCount_req,
  msg_page_req,
  msg_home_req,
  msg_read_req,
  msg_readpist_req,
} from "@/api/message";
import {
  interest_fsPage_req,
  interest_gzPage_req,
  interest_edit_req,
  interest_read_req,
} from "@/api/group";
import Status from "@/components/Status";

export default {
  name: "MessageCenter",
  components: {
    Navbar,
    Status,
    NavbarLeft,
  },
  data() {
    return {
      loginFormShow: false,
      info_cont_height: 500,
      tabIndex: 0,
      // 下拉滚动相关
      pageNum: 1,
      pageSize: 10,
      his_list: [],
      finished: false,
      // 下拉滚动相关

      isShow: true,
    };
  },
  mounted() {
    this.info_cont_height = document.documentElement.clientHeight - 150;
    // this.getMsgPage()
    // this.onLoad()
    console.log(this.$route.params.tabIndex);
    if (
      this.$route.params &&
      this.$route.params.tabIndex &&
      this.$route.params.tabIndex > 0
    ) {
      this.tabClick(this.$route.params.tabIndex);
    } else {
      this.tabClick(0);
    }
  },
  methods: {
    homeBack() {
      this.$router.go(-1);
    },
    tabClick(idx) {
      this.tabIndex = idx;
      this.his_list = [];
      this.pageNum = 1;
      this.finished = false;
      this.isShow = false;
      this.img_page_get(this.tabIndex);
    },
    getMsgPage() {
      msg_page_req({
        type: this.tabIndex,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }).then((res) => {
        this.his_list = res.data.records;
      });
    },

    // 历史记录相关 //
    onRefresh(done) {
      this.his_list = [];
      this.pageNum = 1;
      this.finished = false;
      this.img_page_get(this.tabIndex);
      done();
    },
    onLoad(done) {
      this.img_page_get(this.tabIndex);
      done();
    },
    // 获取历史记录
    img_page_get(val, searchvalue) {
      if (!this.tokenVuex) {
        return;
      }
      this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 1)",
        customClass: "my_loading",
      });

      let _this = this;
      msg_page_req({
        type: this.tabIndex,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      })
        .then((res) => {
          if (res.success) {
            this.isShow = true;

            if (this.tabIndex != 0) {
              msg_readpist_req([this.tabIndex]).then((_res) => {
                this.$store.dispatch("message/changeMesNumAct");
              });
            }
            if (res.data.records.length && this.tabIndex == 0) {
              res.data.records.forEach((item) => {
                if (
                  item.content.substr(0, 1) == "{" &&
                  item.content.substr(-1) == "}"
                ) {
                  item.content = JSON.parse(item.content).reply;
                }
              });
            }
            this.his_list = this.his_list.concat(res.data.records);

            if (this.pageNum >= res.data.pages) {
              this.finished = true;
              return;
            }
            this.pageNum++;
          } else {
            this.his_list = [];
            this.pageNum = 1;
          }
        })
        .catch()
        .finally(() => {
          _this.$loading().close();
        });
    },

    // 历史记录相关 //
    toggleOffice(idx) {
      this.his_list[idx].open = true;
      this.his_list[idx].status = 2;
      this.$forceUpdate();

      msg_read_req(this.his_list[idx].id).then((res) => {
        if (res.data) {
          this.$store.dispatch("message/changeMesNumAct");
        }
      });
    },
    toggleOfficeClose(idx) {
      this.his_list[idx].open = false;
      this.$forceUpdate();
    },
    gotoPersonal(item) {
      let obj = {};
      obj.router = "personal";
      obj.uid = item.uid;
      this.$router.push({
        name: "test", // ⚠️注：这里不能用path路径，只能用name【请对照router.js中的路由规则中的name项】，否则取不到传过去的数据
        params: obj,
      });
    },

    fensiAddGz(item, i) {
      interest_edit_req({
        status: 1,
        fid: item.uid,
      }).then((res) => {
        if (!res.data) return;
        this.his_list[i].isGz = true;
        this.$forceUpdate();
      });
    },
    fensicancelGz(item, i) {
      interest_edit_req({
        status: 2,
        fid: item.uid,
      }).then((res) => {
        if (!res.data) return;
        this.his_list[i].isGz = false;
        this.$forceUpdate();
      });
    },
    readAll() {
      msg_readpist_req([0, 1, 2, 3]).then((_res) => {
        this.$store.dispatch("message/changeMesNumAct");
      });
    },
  },
  computed: {
    tokenVuex() {
      // 存储位置： store.state.{模块名,在store/index.js中module下的}.{state中定义的属性}
      return this.$store.state.user.token;
    },
    totalMessageNum() {
      // 存储位置： store.state.{模块名,在store/index.js中module下的}.{state中定义的属性}
      console.log(this.$store.state.message.totalMessageNum);
      return this.$store.state.message.totalMessageNum;
    },
    officeNum() {
      return this.$store.state.message.officeNum;
    },
    zanNum() {
      return this.$store.state.message.zanNum;
    },
    guanzhuNum() {
      return this.$store.state.message.guanzhuNum;
    },
    yingyongNum() {
      return this.$store.state.message.yingyongNum;
    },
    dongtaiNum() {
      return this.zanNum + this.guanzhuNum + this.yingyongNum;
    },
  },
  watch: {
    tabIndex(newVal, oldVal) {},
  },
};
</script>

<style lang="scss" scoped>
.cont {
  padding: 60px 84px 0;
  box-sizing: border-box;
}

.info_cont {
  width: 950px;
  height: 470px;
  background: #111225;
  border-radius: 20px;
  margin: 0 auto;
  margin-top: 40px;
  .l {
    padding: 18px;
    box-sizing: border-box;
    width: 270px;
    background: #1b1d2e;
    border-radius: 16px 0px 0px 16px;
    .title {
      margin-top: 14px;
      padding-left: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 19px;
      .title_l {
        height: 25px;
        font-size: 18px;
        font-weight: 500;
        color: #ffffff;
        line-height: 25px;
      }
      .title_r {
        height: 20px;
        font-size: 14px;
        color: #006fff;
        line-height: 20px;
        cursor: pointer;
      }
    }
    .l_item {
      display: flex;
      align-items: center;
      width: 234px;
      height: 52px;
      border-radius: 10px;
      padding: 16px 23px;
      color: #9a9ab7;
      font-size: 16px;
      font-weight: 500;
      cursor: pointer;
      &.active {
        background: #252739;
        color: #ffffff;
      }

      .badge {
        padding: 1px 9px;
        min-width: 28px;
        height: 18px;
        background: #ef4545;
        border-radius: 9px;
        text-align: center;
        line-height: 16px;
        color: #ffffff;
      }
    }
  }
  .r {
    width: 680px;
    padding: 24px 24px 0px;
    box-sizing: border-box;
    height: 100%;
    overflow-y: auto;
    .empty {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .desc {
        height: 22px;
        font-family: PingFangSC, PingFang SC;
        color: #49495a;
        line-height: 22px;
        text-align: center;
      }
    }

    .item1 {
      padding: 17px 20px;
      min-height: 82px;
      width: 100%;
      box-sizing: border-box;
      background: #1b1d2e;
      border-radius: 10px;
      margin-bottom: 14px;
      .top {
        height: 20px;
        width: 100%;
        display: flex;
        align-items: center;
        line-height: 20px;
        margin-bottom: 5px;
        .isnew {
          width: 8px;
          height: 8px;
          background: #ef4545;
          border-radius: 50%;
          margin-right: 6px;
        }
        ._title {
          flex: 1;
          margin-right: 13px;
          font-size: 18px;
          color: #ffffff;
          line-height: 20px;
        }
        .date {
          color: #9a9ab7;
          font-size: 16px;
          cursor: pointer;
        }
      }
      ._bot {
        width: 100%;
        height: 16px;
        font-size: 12px;
        color: #9a9ab7;
        line-height: 17px;
        position: relative;
        max-height: 48px;
        overflow: hidden;
        .txt {
          scale: 0.9;
        }
      }
      .content {
        font-size: 16px;
        color: #9a9ab7;
        line-height: 22px;
        margin-top: 10px;
        width: 100%;
        word-wrap: break-word;
      }
      .img_cont {
        display: flex;
        flex-wrap: wrap;
        margin-top: 14px;
      }
    }

    .news_item {
      padding: 18px 24px;
      height: 80px;
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      background: #1b1d2e;
      border-radius: 10px;
      margin-bottom: 14px;
      .ava {
        width: 34px;
        height: 34px;
        border-radius: 50%;
        margin-right: 8px;
        flex-shrink: 0;
      }
      .center {
        height: 40px;
        flex: 1;
        min-width: 0; //新增
        .t {
          height: 20px;
          width: 100%;
          display: flex;
          .name {
            min-width: 0;
            height: 20px;
            font-size: 14px;
            font-weight: 500;
            color: #006fff;
            line-height: 20px;
            margin-right: 4px;
            overflow: hidden; //超出的文本隐藏
            text-overflow: ellipsis; //溢出用省略号显示
            white-space: nowrap; //溢出不换行
            cursor: pointer;
          }
          .value {
            height: 20px;
            font-size: 14px;
            font-weight: 500;
            color: #fff;
            line-height: 20px;
            flex-shrink: 0;
          }
        }
        .b {
          height: 16px;
          font-size: 12px;
          color: #9a9ab7;
          line-height: 16px;
        }
      }
      ._img {
        width: 54px;
        height: 54px;
        border-radius: 8px;
        margin-left: 7px;
        flex-shrink: 0;
      }

      .btn1 {
        width: 88px;
        height: 34px;
        background: #006fff;
        border-radius: 17px;
        color: #fff;
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        line-height: 34px;
      }
      .btn2 {
        width: 88px;
        height: 34px;
        background: #252739;
        border-radius: 17px;
        color: #fff;
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        line-height: 34px;
      }
    }
  }
}

::v-deep .el-tabs {
  width: 100%;
}
</style>
